import { render, staticRenderFns } from "./AdditionalRealProperties.vue?vue&type=template&id=ee7af43a"
import script from "./AdditionalRealProperties.vue?vue&type=script&lang=js"
export * from "./AdditionalRealProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports